<template>
    <div class="about offer_html">
        <div class="body">
            <div class="main" ref="printform">
                <img src="../img/uioffer/muban.jpg" alt="" class="muban">
                <div class="offer_box">
                    <img src="../img/uioffer/offer1.jpg" alt="" class="offer" id="img">
                </div>
                <img src="../img/uioffer/shuiyin.png" alt="" class="shui">
                <!-- <div class="youshang">
                    <p class="en"></p>
                    <p class="cn"></p>
                </div> -->
                <!-- <div class="zuoxia">
                    <p class="p1">{{ value3 }}</p>
                    <p class="p2"> —— {{ value4 }} {{ value5 }}</p>
                </div> -->
                <div class="cont_left">
                    <div class="fonts1 fonts">{{ value3 }}</div>
                    <div class="fonts2 fonts">{{ value4 }}</div>
                </div>
                <div class="cont_right">
                    <div class="fonts2 fonts fonts3" id="trUp">{{ value1 }}</div>
                    <div class="fonts4 fonts">{{ value2 }}</div>
                </div>
                
                <!-- FIDM -->
                <div class="zhongjian" ref="zhongjianRef">
                    <div class="zhongjianen">
                        {{ value6 }}
                    </div>
                </div>
                <!-- <div class="nyu">
                    <div class="nyu_cont">
                        {{ value6 }}
                    </div>
                </div> -->
                <div class="jiang">
                    <img src="../img/uioffer/ship.png" alt="" class="shipImg">
                    <div class="ship_cont">
                        <p class="ship1 shipp">奖学金</p>
                        <p class="ship2 shipp" id="money">{{ value7 }}</p>
                        <p class="ship3 shipp">{{ value8 }}</p>
                    </div>
                </div>
            </div>


            <div class="writ">
             
                <p>offer&#x3000;&nbsp;&nbsp;<input type="file" name="" id="inpimg" @change="inpImgonchange($event)"></p>
                
                <p>姓名&#x3000;&#x3000;<input type="text" name="" id="" v-model="value3"></p>
                <p>院校中文<input type="text" name="" id="" v-model="value2"></p>
                <p>院校英文<input type="text" name="" id="" v-model="value1" @change="exUpcase"></p>
                <p>院校缩写<input type="text" name="" id="" v-model="value6" @change="handleTextAdaptive2"></p>
                <p>专业&#x3000;&#x3000;<input type="text" name="" id="" v-model="value4"></p>
                <!-- <p>学位<input type="text" name="" id="" v-model="value5"></p> -->
              
                <!-- handleTextAdaptive2 -->
                
                <div style="margin: 0 auto;font-weight: bold;font-size: 18px;">奖学金(有则添加)</div>
                <p>金额&#x3000;&#x3000;<input type="text" v-model="value7" @change="shipNone"></p>
                <!-- <p>单位&#x3000;&#x3000;<input type="text" v-model="value8" @change="shipNone"></p> -->
                <div @click="generatorImage" class="subBtn">提交导出图片</div>
            </div>
        </div>


        <div class="offerList">
            <input type="file" id="file-input" accept=".xlsx, .xls" @change="convertExcelToJson" />
            <div class="main2" id="main2" ref="printform2">

            </div>
            <button @click="generatorImage2">导出offerlist</button>
        </div>

    </div>
</template>

<script>

//需要的插件
import html2canvas from "html2canvas";
import { read, utils, writeFile } from 'xlsx';
export default {
    data() {
        return {
            value1: "Royal College of Music",
            value2: "皇家音乐学院",
            value3: "Shi同学",
            value4: "西洋打击乐- BMus (Hons)",
            value5: "",
            value6: "SSS",
            value7: "",
            value8: "人民币",
        }
    },
    created() {
    },
    
    methods: {
        exUpcase() {
            this.value1 = this.value1.toUpperCase()
            console.log(trUp.offsetWidth,"trUp.width");
            if(trUp.offsetWidth > 325){
                trUp.style.letterSpacing = "-1px"
            }
        },
        convertExcelToJson(file) {
            console.log(file);
            const reader = new FileReader();

            reader.onload = function (e) {
                const data = new Uint8Array(e.target.result);
                var workbook = XLSX.read(data, { type: 'array' });


                const worksheet = workbook.Sheets[workbook.SheetNames[0]];
                const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

                const headers = jsonData[0];
                const rows = jsonData.slice(1);

                const result = rows.map(row => {
                    const obj = {};
                    headers.forEach((header, index) => {
                        obj[header] = row[index];
                    });
                    return obj;
                });

                // console.log(result);

                // 在这里可以对result进行进一步处理，如发送到服务器或进行其他操作

                result.forEach((item, index) => {
                    main2.innerHTML +=
                        `
                   <div class="item">
                       <p>${item.院校}</p>
                       <p>${item.数量}</p>
                   </div>
                   `
                })
            };

            reader.readAsArrayBuffer(file.target.files[0]);
        },
        generatorImage2() {
            html2canvas(this.$refs.printform2, {
                allowTaint: true,
                taintTest: false,
                useCORS: true,
                dpi: window.devicePixelRatio * 4, //将分辨率提高到特定的DPI 提高四倍
                scale: 4, //按比例增加分辨率
            }).then((canvas) => {
                let link = document.createElement("a");
                link.href = canvas.toDataURL("image/jpeg", 1.0); //下载链接
                
                link.setAttribute(
                    "download",
                    `test.png`
                );
                link.style.display = "none"; //a标签隐藏
                document.body.appendChild(link);
                link.click();
            });
        },


        // 输出
        generatorImage() {
            html2canvas(this.$refs.printform, {
                allowTaint: true,
                taintTest: false,
                useCORS: true,
                dpi: window.devicePixelRatio * 4, //将分辨率提高到特定的DPI 提高四倍
                scale: 2, //按比例增加分辨率
            }).then((canvas) => {
                let link = document.createElement("a");
                link.href = canvas.toDataURL("image/jpeg", 1.0); //下载链接
                link.setAttribute(
                    "download",
                    `test.png`
                );
                link.style.display = "none"; //a标签隐藏
                document.body.appendChild(link);
                link.click();
            });
        },
        // 字号
        // handleTextAdaptive() {
        //     let domContainer = document.querySelector('.youshang');
        //     let domText = domContainer.querySelector('.en');
        //     // console.log(domText.clientWidth, domContainer.clientWidth);
        //     if (domText.clientWidth <= domContainer.clientWidth) {
        //         domText.style.transform = 'none';
        //     } else {
        //         let r = 350 / domText.clientWidth;
        //         domText.style.transform = 'scale(' + r + ')';
        //     }
        // },
        handleTextAdaptive2() {
            let domContainer = document.querySelector('.zhongjian');
            let domText = domContainer.querySelector('.zhongjianen');
            console.log(domText.clientWidth, domContainer.clientWidth);
            if (domText.clientWidth <= domContainer.clientWidth) {
                let r = 320 / domText.clientWidth;
                console.log("if",r);
                domText.style.transform = 'scale(' + r + ')';
                // domText.style.transform = `translateY(${46*r}px) scale(${r})`;
                // domText.style.transform = "translateY("+ 46 +"px)";
                // ppp.style.transform = 'scale(' + r + ')';
            } else {
                let r = 320 / domText.clientWidth;
                console.log("else",r);
                domText.style.transform = 'scale(' + r + ')';
                // if (0.8 < r < 1) {
                //     this.$refs.zhongjianRef.style.left = '15px'
                // } else if ( 0.35 < r < 0.55) {
                //     this.$refs.zhongjianRef.style.left = '10px'
                // }
                // domText.style.transform = `translateY(${46*r}px) scale(${r})`;
                // ppp.style.transform = 'scale(' + r + ')';
            }
        },
        inpImgonchange(e) {
            console.log(e.target.files[0]);
            var file = e.target.files[0];
            img.style.width = 370 + "px"
            // console.log(file)
            if (window.FileReader) {
                var reader = new FileReader();
                reader.readAsDataURL(file);
                //监听文件读取结束后事件    
                reader.onloadend = function (e) {
                    //e.target.result就是最后的路径地址
                    document.getElementById("img").setAttribute("src", e.target.result)
                    // console.log("***" + e.target.result);

                };
                this.getOfferOver()
            }
        },
        
        formatWithCommas(number) {
            var numStr = number.toString();
            return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        getOfferOver() {
            var img = document.getElementById("img")
            setTimeout(() => {
                // 420 550  || 380 510
                // 380 640 
                console.log(img.width, img.offsetHeight, 510 / img.offsetHeight * 370);
                if (img.offsetHeight > 510) {
                    img.style.width = 510 / img.offsetHeight * 370 + "px"
                }

            }, 500);
        },
        shipNone() {
            var jiang = document.getElementsByClassName("jiang")
            let moneyWidth = document.getElementById('money');
            // console.log(moneyWidth.clientWidth);

            if (moneyWidth.clientWidth > 155) {
                let r = 155 / moneyWidth.clientWidth;
                moneyWidth.style.transform = 'scale(' + r + ')';
                console.log("yes");
            } else {

            }

            if (this.value7 == 0 ) {
                jiang[0].style.display = "none"
            } else {
                this.value7 = this.formatWithCommas(this.value7)
                jiang[0].style.display = "flex"
            }
        }
    },
    mounted() {
        // this.handleTextAdaptive()
        this.shipNone()
        this.exUpcase()
        setTimeout(()=>{
            this.handleTextAdaptive2()
        },100)
    }
}
</script>

 

<style lang="less" scoped>
.offer_html {
    padding: 0;
    margin: 0;
    margin-top: 100px;
    /* @font-face {
    font-family: futura;
    src: url(../img/uioffer/Futura.ttc);
}

@font-face {
    font-family: futuraBold;
    src: url(../img/uioffer/FuturaLTExtraBold.ttf);
} */

    @font-face {
        font-family: lanting;
        src: url(../img/uioffer/lanting.ttc);
    }

    @font-face {
        font-family: ysEn;
        src: url(../img/uioffer/unicode.futurab.ttf);
    }
    @font-face {
        font-family: ysEn2;
        src: url(../img/uioffer/unicode.futurab2.ttf);
    }
    @font-face {
        font-family: ysEn3;
        src: url(../img/uioffer/Futura LT W04 Extra Bold.woff);
    }

    .offerList {
        margin-top: 200px;
        border: 1px solid #000;
        // display: none;
    }

    .main2 {
        width: 300px;
        height: 500px;
        border: 1px solid #000;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-content: flex-start;
        font-size: 0;

        .item {
            width: 70px;
            height: 100px;
            border: 1px solid #000;

            p {
                font-size: 12px;
                text-align: center;
            }
        }
    }





    /* ????????????????????????????????????????/ */


    .body {
        width: 1000px;
        // border: 1px solid #000;
        display: flex;
        margin: 0 auto;
        justify-content: space-between;
        margin-bottom: 200px;
        .writ{
            height: 400px;
            // border: 1px solid #000;
            display: flex;
            margin-top: 50px;
            flex-direction: column;
            align-items: flex-start;
            // padding-left: 20px;
            justify-content: space-between;
            #inpimg{
                border: 1px solid #000;
                // width: 40px; 
                height: 60px; 
                cursor: pointer; 
                
            }
           
            input{
                width: 220px;
                height: 22px;
                padding-left: 10px;
            }

            input:focus{
                // border: none;
                outline: none;
            }
            div{
                margin: 0 auto;
            }
        }

    }

    .main {
        width: 600px;
        height: 850px;
        /* background:linear-gradient(to right,hotpink,black); */
        /* border: 10px solid #fff; */
        position: relative;
        overflow: hidden;
    }
    .cont_left {
        position: absolute;
        height: 40px;
        left: 35px;
        // border: 1px solid #000;
        text-align: left;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        color: #20adf4;
        top: 135px;
        .fonts {
            line-height: 1;
            // font-weight: bold!important;
        }
        .fonts1 {
            font-size: 24px;
            letter-spacing: 1px;
            font-family: lanting;
        }
        .fonts2 {
            font-size: 14px;
            letter-spacing: 1px;
            font-family: lanting;
            white-space: nowrap;
        }
    }
    .cont_right {
            position: absolute;
            top: 30px;
            right: 20px;
            height: 50px;
            // border: 1px solid #000;
            text-align: right;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            color: #20adf4;
            
            .fonts {
                line-height: 1;
                // font-weight: bold!important;
            }
            .fonts2 {
                font-size: 16px;
                letter-spacing: 0px;
                font-family: lanting;
                white-space: nowrap;
            }
            .fonts3{
                // max-width: 410px;
                font-family: ysEn2;
                font-size: 16px;
                // border: 1px solid #000;
                overflow: hidden;
            }
            .fonts4 {
                font-size: 28px;
                letter-spacing: 1px;
                font-family: lanting;
                // width: 325px;
            }
        }
    

    .muban {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;

    }

    .ship1 {
        font-size: 20px;
    }

    .ship2 {
        font-size: 30px;
        // font-weight: bold;
        margin-top: -3px;
        // border: 1px solid #000;
    }

    .ship3 {
        font-size: 20px;
        margin-top: -3px;
    }

    .shipp {
        height: 35px;
        line-height: 35px;
        // font-weight: bold;
        font-family: lanting;
    }

    .shui {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
    }

    .offer_box {
        width: 370px;
        height: 510px;
        // border: 1px solid #000;
        position: absolute;
        top: 184px;
        left: 38px;
        overflow: hidden;
    }

    .offer {
        max-width: 370px;
        margin: 20px auto;
        // border: 1px solid yellow; 
        // min-height: 510px;

        // transform: translateX(-50%);
    }

    .youshang {
        width: 350px;

        height: 45px;
        /* max-width: 400px; */
        /* border: 1px solid #000; */
        position: absolute;
        right: 35px;
        top: 33px;
        text-align: right;
        /* display: flex;  */
        /* flex-direction: column; */
        /* justify-content: space-between; */


    }


    .en {
        /* width: 100%; */
        white-space: nowrap;
        font-weight: bold;
        color: #000;
        display: inline-block;
        transform-origin: left center;
        font-family: ysEn;
    }

    .nyu {
        width: 360px;
        border: 1px solid hotpink;
        position: absolute;
        bottom: 204px;
        right: 15px;
    }

    .zhongjian {
        width: 335px;
        height: auto;
        // border: 1px solid red;
        position: absolute;
        // left: calc(50% - 210px);
        left: 24px;
        bottom: 133px;
        // 158
        // font-weight: 1000;
        display: flex;
        justify-content: flex-start;
        align-items: flex-end;
        color: #00B1FF;
        font-size: 0;
        // background:red;
        .zhongjianen {
            // width: 360px;
            height: auto;
            text-align: left;
            text-indent: -7px;
            // border: 1px solid #000;
            font-size: 98px;
            white-space: nowrap;
            // font-weight: bolder;
            letter-spacing: -6px;
            transform-origin:left bottom ;
            line-height: 71px;
            // margin-right: 10px;
            // background-color: #999;
            // transform: translateY(46px);
            // margin-bottom: -46px;
            // position: absolute;
            // font-family: Avenir, Helvetica, Arial!important;
            // font-family: ysEn!important;
            // font-family: ysEn!important;
            font-family: ysEn3!important;
            // font-family: ysEn,ysEn2,ysEn3!important;
            // bottom: -46px;
            // -webkit-font-smoothing: auto;
            // font-smooth: auto;
            // transform: scale(1.2766);
        }
    }


    .cn {
        width: 100%;
        height: 28px;
        line-height: 28px;
        color: #000;
        /* border: 1px solid #000; */
        font-weight: bold;
        font-size: 20px;
        white-space: nowrap;
        font-family: lanting;

    }

    .zuoxia {
        width: 350px;
        height: 44px;
        /* border: 1px solid #000; */
        position: absolute;
        left: 35px;
        bottom: 30px;
        font-family: lanting;
        text-align: left;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .p1 {
        height: 22px;
        line-height: 22px;
        color: #000;
        font-weight: bold;
    }

    .p2 {
        height: 22px;
        line-height: 22px;
        color: #000;
        font-weight: bold;
        letter-spacing: 0px;
    }

    .subBtn {
        width: 150px;
        height: 30px;
        border: 2px solid #000;
        line-height: 30px;
        border-radius: 20px;
        color: black;
        background-color: #e3e1e1;
        cursor: pointer;
        font-weight: bold;
        // margin: 20px auto;
    }
    .subBtn:hover{
        background-color: #fb6333;
        color: #fff;
    }

    .jiang {
        width: 180px;
        height: 180px;
    //    border: 1px solid #000;
        position: absolute;
        right: 113px;
        top: 378px;
        font-family: lanting;
    }

    .shipImg {
        width: 180px;
        height: 180px;
        position: absolute;
        top: 0;
        left: 0;
        transform: rotate(60deg);
    }

    .ship_cont {
        width: 160px;
        height: 160px;
        // border: 1px solid #000; 
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #000;
        position: absolute;
        top: calc(50% - 80px);
        left: calc(50% - 80px);
        transform: rotate(20deg);
        transform-origin: 50%;
    }

    .cont {
        width: 566px;
        height: 50px;
        // border: 1px solid #000;
        position: absolute;
        left: calc(50%);
        transform: translateX(-50%);
        bottom: 126px;
        display: flex;
        justify-content: space-between;
        font-weight: normal;

        color: #fff;
        z-index: 2;

        

        

        

       
        

    }
}</style>